import { useGetProdottiQuery } from "../store/services/LookUpService"

export default function ProdottiLookUp() {
    const {data} = useGetProdottiQuery('');

    let optionProdotti = data?.map((prodotto: any) => ({value: prodotto?.id, label: prodotto?.nome, price: prodotto?.prezzoConsigliato}))
    return optionProdotti;
}